import _get from 'lodash/get';
import _includes from 'lodash/includes';
import {
  DEFAULT_LABEL_TEXT_I18N,
  NONE_EDITING_LABEL,
} from 'constants/geo-constants';
import I18n from 'i18n-js';
import { addressDetailFormField } from './form-validator';

export const generateAddressDetailUpdate = (currentPOI, newPOI) => {
  // Compare current label, sp_ext_info and generate new update date
  const currentLabel = _get(currentPOI, 'label');
  const currentExtInfo = _get(currentPOI, 'sp_ext_info', {});
  const newLabel = _get(newPOI, 'label');
  const newExtInfo = _get(newPOI, 'sp_ext_info', {});

  return {
    [addressDetailFormField.savedPlaceLabel.fieldName]:
      currentLabel || newLabel,
    [addressDetailFormField.addressDetail.fieldName]:
      currentExtInfo.address_details || newExtInfo.address_details,
    [addressDetailFormField.locationNote.fieldName]:
      currentExtInfo.note_to_driver || newExtInfo.note_to_driver,
    [addressDetailFormField.contactName.fieldName]:
      currentExtInfo.contact_name || newExtInfo.contact_name,
    [addressDetailFormField.contactNumber.fieldName]:
      currentExtInfo.contact_number || newExtInfo.contact_number,
  };
};

export const getDisplayLabel = label => {
  if (_includes(NONE_EDITING_LABEL, label)) {
    return I18n.t(DEFAULT_LABEL_TEXT_I18N[label]);
  }
  return label;
};

export default {};
